var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('LoadingContainer'):_c('div',[_c('FormPanel',{attrs:{"headline":"Create Registration","errors":_vm.errors,"company-id":_vm.portalCompany.attributes.company_id,"content-registration-categories":_vm.contentRegistrationCategories,"initial":{gallery_images: []}},on:{"submit":_vm.submit}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }